import { Controller } from '@hotwired/stimulus';
import { CountUp } from 'countup.js';

export default class extends Controller {
    static targets = ['counter', 'style'];
    static values = {
        end: Number,
        duration: {
            type: Number,
            default: 3
        },
        suffix: {
            type: String,
            default: ''
        },
        styleTemplate: String,
    };

    connect () {
        this.countUp = new CountUp(this.hasCounterTarget ? this.counterTarget : this.element, this.endValue, {
            duration: this.durationValue,
            suffix: this.suffixValue,
            formattingFn: (value) => {
                this._updateStyles(value);

                return `${value}${this.suffixValue}`;
            }
        });
    }

    start () {
        this.countUp.start();
    }

    reset () {
        this.countUp.reset();
    }

    _updateStyles (value) {
        if (!this.hasStyleTarget || !this.hasStyleTemplateValue) {
            return;
        }

        this.styleTarget.style.cssText = this.styleTemplateValue.replaceAll('{value}', value);
    }
}
